var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBasket = function SvgBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\n    My Bag\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M0 6h19v12H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 7h17v10H1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M9.5 0A4.5 4.5 0 0114 4.5V8H5V4.5A4.5 4.5 0 019.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1h0A3.5 3.5 0 0113 4.5v1.625a.875.875 0 01-.875.875h-5.25A.875.875 0 016 6.125V4.5A3.5 3.5 0 019.5 1zM6.1 6.5v10M13.1 6.5v10"
  }))));
};
export default SvgBasket;